export const REFRESH_ERROR_COPY = "Saved, but couldn't refresh the page. Reload to see the latest.";

export const REFRESH_ERROR = { displayMessage: REFRESH_ERROR_COPY };
